interface FeatureItem {
  icon: string;
  title: string;
  desc: string;
}

const features: FeatureItem[] = [
  {
    icon: 'ri-hd-line',
    title: '1080P高清画质',
    desc: '全剧集提供1080P高清播放，支持画质自适应切换，网速不佳时自动降档保证流畅，带宽充裕时享极致清晰。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速播放不缓冲',
    desc: '全球多节点CDN加速，智能调度最优线路。无论是高峰时段还是深夜追剧，都能享受丝滑流畅的播放体验。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全平台无缝追剧',
    desc: '电脑、手机、平板全平台支持，自动同步观看进度。iOS和Android专属APP支持离线缓存，没网也能看。',
  },
  {
    icon: 'ri-moon-clear-line',
    title: '夜间护眼模式',
    desc: '专为夜猫子设计的深色主题界面，降低屏幕蓝光刺激，保护视力同时提升沉浸式观影体验，熬夜追剧不伤眼。',
  },
  {
    icon: 'ri-global-line',
    title: '海量多语言剧集',
    desc: '收录国产、韩剧、美剧、日剧等多语种剧集，专业字幕团队精心翻译，同步更新速度行业领先。',
  },
];

export default function SectionFeatures() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          平台特色
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">为什么800万夜猫子选择我们</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {features.slice(0, 3).map((item, idx) => (
            <div key={idx} className="bg-background-100 rounded-xl p-6 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer">
              <span className="w-11 h-11 rounded-xl bg-primary-100 flex items-center justify-center mb-4">
                <i className={`${item.icon} text-xl text-primary-600`}></i>
              </span>
              <h3 className="font-heading text-sm text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 mt-4 md:mt-5 max-w-3xl mx-auto">
          {features.slice(3).map((item, idx) => (
            <div key={idx} className="bg-background-100 rounded-xl p-6 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer">
              <span className="w-11 h-11 rounded-xl bg-accent-100 flex items-center justify-center mb-4">
                <i className={`${item.icon} text-xl text-accent-600`}></i>
              </span>
              <h3 className="font-heading text-sm text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}